import { Injectable } from '@angular/core';

import { LegFiJwtService } from './auth/legfi-jwt.service';
import { AuthService } from 'app/services/auth/auth.service';
import { FileItem, FileUploader, FileUploaderOptions, Headers } from 'ng2-file-upload';
import environment from 'environments/environment';

/** Re-reads the auth headers as each item starts, so an uploader built before a JWT or XSRF rotation never sends stale ones (a 419). */
export class FreshHeadersFileUploader extends FileUploader {
    constructor(options: FileUploaderOptions, private readonly _authHeaders: () => Headers[]) {
        super(options);
    }

    override uploadItem(value: FileItem): void {
        const fresh = this._authHeaders();
        const names = new Set(fresh.map(header => header.name));
        this.options.headers = [...(this.options.headers ?? []).filter(header => !names.has(header.name)), ...fresh];
        super.uploadItem(value);
    }
}

@Injectable({
    providedIn: 'root',
})
export class FileUploaderService
{
    constructor(
            private _authService: AuthService,
    ) {
    }

    public initUploader(options: Partial<FileUploaderOptions>): FileUploader {
        const uploaderOptions: FileUploaderOptions = {
            url: options.url || '',
            ...options,
            headers: this.authHeaders(),
        };

        return new FreshHeadersFileUploader(uploaderOptions, () => this.authHeaders());
    }

    private authHeaders(): Headers[] {
        return [
            {
                name: 'X-Legfi-Site-Id',
                value: environment.SiteId.toString(),
            },
            {
                name: 'Authorization',
                value: 'Bearer ' + LegFiJwtService.raw(),
            },
            {
                name: 'X-XSRF-TOKEN',
                value: this._authService.getCookie('XSRF-TOKEN'),
            },
        ];
    }
}
